import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/buyers";
import { MOCKUP_URL } from "../data/site";
const FIRST_DELAY_MS = 5000;
const VISIBLE_MS = 5000;
const HIDDEN_MS = 8000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timer = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(i => (i + 1) % buyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY_MS : HIDDEN_MS);
    return () => window.clearTimeout(timer);
  }, [visible, index, dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-45" data-mp="1gydwu4yb0xlk">
      <AnimatePresence data-id="element-46" data-mp="117fsm8rns5ui">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_16px_40px_-10px_rgba(10,27,63,0.45)] ring-1 ring-line" data-id="element-47" data-mp="114th5y1nd670">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-canvas object-contain" data-id="element-48" data-mp="x62n5zsha4o4" />
            <div className="min-w-0" data-id="element-49" data-mp="s4n1q6me1w57">
              <p className="text-sm leading-snug text-ink" data-id="element-50" data-mp="28kg6qsg77xyc">
                <span className="font-extrabold" data-id="element-51" data-mp="28imvt0yjyrkj">{buyer.name}</span> from <span className="font-bold" data-id="element-52" data-mp="23lwk0pts6i4x">{buyer.country}</span> just
                purchased the <span className="font-bold text-navy-700" data-id="element-53" data-mp="2aotia7mktlfi">Hemodynamic Monitoring Blueprint™</span>
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-cta-dark" data-id="element-54" data-mp="2fmv2wwznhst3">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-55" data-mp="2km7l34fkubpc" />
                Verified purchase · {buyer.minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:bg-canvas hover:text-ink" aria-label="Close notification" data-id="element-56" data-mp="1ry3hqpkhaapt">
              <XIcon className="h-4 w-4" data-id="element-57" data-mp="21uexjpja1ip0" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}